export const Endpoints = {
  dashboard: {
    summary: '/v1/api/dashboard/summary',
    securityStatus: '/v1/api/dashboard/security/status',
    clients: '/v1/api/dashboard/clients',
    client: (id: string) => `/v1/api/dashboard/clients/${id}`,
    registerClient: (id: string) => `/v1/api/dashboard/clients/${id}/register`,
    blockClient: (id: string) => `/v1/api/dashboard/clients/${id}/block`,
    suspendClient: (id: string) => `/v1/api/dashboard/clients/${id}/suspend`,
    reactivateClient: (id: string) => `/v1/api/dashboard/clients/${id}/reactivate`,
    updateContact: (id: string) => `/v1/api/dashboard/clients/${id}/contact`,
    setBalance: (id: string) => `/v1/api/dashboard/clients/${id}/balance/set`,
    addBalance: (id: string) => `/v1/api/dashboard/clients/${id}/balance/add`,
    changeExpiry: (id: string) => `/v1/api/dashboard/clients/${id}/balance/expiry`,
    rotateKey: (id: string) => `/v1/api/dashboard/clients/${id}/rotate-key`,
    pricing: (id: string) => `/v1/api/dashboard/clients/${id}/pricing`,
    balanceTransfer: (id: string) => `/v1/api/dashboard/clients/${id}/balance-transfer`,
    fullOnboard: '/v1/api/dashboard/clients/onboard',
    verifications: '/v1/api/dashboard/verifications',
    myClient: '/v1/api/dashboard/me/client',
    myVerifications: '/v1/api/dashboard/me/verifications',
    adminOpportunities: '/v1/api/dashboard/opportunities',
    adminOpportunityStats: '/v1/api/dashboard/opportunities/stats',
  },

  clients: {
    me: '/v1/api/clients/me',
    rotateKey: (id: string) => `/v1/api/clients/${id}/rotate-key`,
    apiKeys: (id: string) => `/v1/api/clients/${id}/api-keys`,
    apiKey: (clientId: string, keyId: string) =>
      `/v1/api/clients/${clientId}/api-keys/${keyId}`,
  },

  verifications: {
    list: '/v1/api/verify/recent',
    byClient: (clientId: string) => `/v1/api/verify/client/${clientId}`,
  },

  analytics: {
    overview: '/v1/api/analytics/overview',
    usage: '/v1/api/analytics/usage',
  },

  billing: {
    summary: '/v1/api/billing/summary',
    invoices: '/v1/api/billing/invoices',
  },

  opportunity: {
    campaignStats: '/v1/api/opportunity/campaign-stats',
  },

  me: {
    apiKeyGenerate: '/v1/api/me/api-key/generate',
    apiKeyRotate: '/v1/api/me/api-key/rotate',
    sdkTokenRotate: '/v1/api/me/sdk-token/rotate',
    clientSecret: '/v1/api/me/client-secret',
    overview: '/v1/api/me/overview',
    usage: '/v1/api/me/usage',
    verifications: '/v1/api/me/verifications',
    opportunities: '/v1/api/me/opportunities',
    opportunitiesGrouped: '/v1/api/me/opportunities/grouped',
    opportunityStats: '/v1/api/me/opportunities/stats',
    subscription: '/v1/api/me/subscription',
    balanceHistory: '/v1/api/me/balance-history',
    requests: '/v1/api/me/requests',
    requestsUnreadCount: '/v1/api/me/requests/unread-count',
    requestsAcknowledge: '/v1/api/me/requests/acknowledge',
    team: '/v1/api/me/team',
    teamInvite: '/v1/api/me/team/invite',
    teamMemberRole: (userId: string) => `/v1/api/me/team/${userId}/role`,
    teamMemberResetPassword: (userId: string) => `/v1/api/me/team/${userId}/reset-password`,
    teamMemberSuspend: (userId: string) => `/v1/api/me/team/${userId}/suspend`,
    teamMemberReactivate: (userId: string) => `/v1/api/me/team/${userId}/reactivate`,
    products: '/v1/api/me/products',
    productCatalog: '/v1/api/me/product-catalog',
    riskEvents: '/v1/api/me/risk-events',
    riskSummary: '/v1/api/me/risk-summary',
    stuckPlus: {
      overview: '/v1/api/me/stuck-plus/overview',
      sessions: '/v1/api/me/stuck-plus/sessions',
      reveals: '/v1/api/me/stuck-plus/reveals',
      reveal: (sessionId: string) => `/v1/api/me/stuck-plus/sessions/${sessionId}/reveal`,
      reset: (sessionId: string) => `/v1/api/me/stuck-plus/sessions/${sessionId}/reset`,
      journey: (sessionId: string) => `/v1/api/me/stuck-plus/sessions/${sessionId}/journey`,
    },
    connect: {
      overview: '/v1/api/me/connect/overview',
      integrations: '/v1/api/me/connect/integrations',
      integration: (id: string) => `/v1/api/me/connect/integrations/${id}`,
      syncHistory: (integrationId: string) => `/v1/api/me/connect/integrations/${integrationId}/sync-history`,
      profiles: '/v1/api/me/connect/profiles',
      // ── Import ──────────────────────────────────────────────
      importParse:  '/v1/api/me/connect/import/parse',
      importStart:  '/v1/api/me/connect/import/start',
      importJobs:   '/v1/api/me/connect/import/jobs',
      importSample: '/v1/api/me/connect/import/sample.csv',
    },
  },

  adminStuckPlus: {
    overview: (clientId?: string) => clientId
      ? `/v1/api/dashboard/stuck-plus/overview?clientId=${clientId}`
      : '/v1/api/dashboard/stuck-plus/overview',
    sessions: (clientId?: string) => clientId
      ? `/v1/api/dashboard/stuck-plus/sessions?clientId=${clientId}`
      : '/v1/api/dashboard/stuck-plus/sessions',
    reveals: (clientId?: string) => clientId
      ? `/v1/api/dashboard/stuck-plus/reveals?clientId=${clientId}`
      : '/v1/api/dashboard/stuck-plus/reveals',
    config: (clientId: string) => `/v1/api/dashboard/clients/${clientId}/stuck-plus/config`,
  },

  adminConnect: {
    overview: (clientId?: string) => clientId
      ? `/v1/api/dashboard/connect/overview?clientId=${clientId}`
      : '/v1/api/dashboard/connect/overview',
    integrations: (clientId?: string) => clientId
      ? `/v1/api/dashboard/connect/integrations?clientId=${clientId}`
      : '/v1/api/dashboard/connect/integrations',
    syncHistory: (integrationId: string) => `/v1/api/dashboard/connect/sync-history?integrationId=${integrationId}`,
    config: (clientId: string) => `/v1/api/dashboard/clients/${clientId}/connect/config`,
    profiles: (clientId: string) => `/v1/api/dashboard/clients/${clientId}/connect/profiles`,
    syncEvents: (clientId: string) => `/v1/api/dashboard/clients/${clientId}/connect/sync-events`,
  },

  meProfile: {
    get: '/v1/api/me/profile',
    update: '/v1/api/me/profile',
    requestPasswordUpdate: '/v1/api/me/request-password-update',
  },

  adminRequests: {
    list: '/v1/api/dashboard/client-requests',
    pendingCount: '/v1/api/dashboard/client-requests/pending-count',
    review: (id: string) => `/v1/api/dashboard/client-requests/${id}/review`,
  },

  adminProducts: {
    list: '/v1/api/dashboard/products',
    clientProducts: (clientId: string) => `/v1/api/dashboard/clients/${clientId}/products`,
    updateClientProduct: (clientId: string, productCode: string) =>
      `/v1/api/dashboard/clients/${clientId}/products/${productCode}`,
  },

  adminRiskEvents: {
    list: '/v1/api/dashboard/risk-events',
  },

  shield: {
    assess: '/v1/api/shield/assess',
  },
  detect: {
    analyze: '/v1/api/detect/analyze',
  },
  trust: {
    score: '/v1/api/trust/score',
  },
} as const;
